import { Check, Warning } from '@mui/icons-material';
import {
  alpha,
  Avatar,
  Box,
  Button,
  Container,
  Modal,
  Paper,
  Stack,
  styled,
  Typography,
  useTheme,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  ButtonsPrimary,
  ButtonXcalaBlue,
} from '../../components/ComponentApp/buttoms/ButtonsXcala';

const StyledPaper = styled(Paper)(({ theme }) => ({
  borderRadius: 12,
  width: '90%',
  margin: '0 auto',
}));

const WrapperBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  paddingTop: 3,
  paddingBottom: 3,
  paddingLeft: 6,
  paddingRight: 6,
}));

const GifContainer = styled(Stack)(({ theme }) => ({
  width: '80px',
  height: '80px',
  marginBottom: 2,
  '& img': {
    width: '100%',
    height: '100%',
    display: 'block',
  },
}));

const TitleText = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: theme.typography.h1.fontWeight,
  fontSize: theme.typography.button.fontSize,
  [theme.breakpoints.up('sm')]: {
    fontSize: theme.typography.titleText.fontSize,
  },
}));

const ProductName = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: theme.typography.returnText.fontSize,
  [theme.breakpoints.up('sm')]: {
    fontSize: theme.typography.button.fontSize,
    fontWeight: theme.typography.titleText.fontWeight,
  },
}));

const LabelAmount = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.main,
  fontSize: theme.typography.button.fontSize,
  [theme.breakpoints.up('sm')]: {
    fontSize: theme.typography.titleText.fontSize,
  },
}));

const AmountValue = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.main,
  fontWeight: theme.typography.h1.fontWeight,
  fontSize: theme.typography.button.fontSize,
  [theme.breakpoints.up('sm')]: {
    fontSize: theme.typography.titleText.fontSize,
  },
}));

const ButtonBox = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  padding: `0 ${theme.spacing(2)} ${theme.spacing(4)}`,
}));

const modalStyles = {
  wrapper: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    p: 4,
    width: {
      xs: '100%',
      sm: '80%',
      md: 500,
    },
    maxWidth: '100%',
  },
  inputFields: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '20px',
    marginBottom: '15px',
    '.MuiInput-root': {
      marginBottom: '20px',
    },
  },
  buttons: {
    display: 'flex',
    justifyContent: 'end',
  },
};
const ModalActions = ({ children, open, onClose, content }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyles.wrapper}>{content ? content : children}</Box>
    </Modal>
  );
};

export default ModalActions;

// casos de errores nuevos
export const RequestFailed = ({ onClose }) => {
  const navigate = useNavigate();
  return (
    <Container maxWidth='sm'>
      <Paper elevation={12} sx={{ borderRadius: 4 }}>
        <Box
          sx={{
            display: 'flex',
            pb: 2,
            pt: 3,
            px: 3,
          }}>
          <Avatar
            sx={{
              backgroundColor: theme => alpha(theme.palette.success.main, 0.08),
              color: 'success.main',
              mr: 2,
            }}>
            <Warning fontSize='large' />
          </Avatar>

          <div>
            <Typography variant='h5'>¡Oh no! parece que algo salio mal</Typography>
            <Typography color='textSecondary' sx={{ mt: 1 }} variant='body2'>
              Hemos tenido problemas para validar tu solicitud.
            </Typography>
          </div>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            px: 3,
            py: 1.5,
          }}>
          <Button
            sx={{ mr: 2 }}
            variant='outlined'
            onClick={() => {
              onClose();
              navigate('/profilerisk');
            }}>
            Cancelar
          </Button>
          <ButtonXcalaBlue
            onClick={() => {
              onClose();
              navigate('/wallet');
            }}>
            ¡Reintentalo!
          </ButtonXcalaBlue>
        </Box>
      </Paper>
    </Container>
  );
};
export const ReturnToForm = ({ onClose }) => {
  const navigate = useNavigate();
  return (
    <Container maxWidth='sm'>
      <Paper elevation={12} sx={{ borderRadius: 4 }}>
        <Box
          sx={{
            display: 'flex',
            pb: 2,
            pt: 3,
            px: 3,
          }}>
          <Avatar
            sx={{
              backgroundColor: theme => alpha(theme.palette.success.main, 0.08),
              color: 'success.main',
              mr: 2,
            }}>
            <Warning fontSize='large' />
          </Avatar>

          <div>
            <Typography variant='h5'>¡Oh no! parece que algo salio mal</Typography>
            <Typography color='textSecondary' sx={{ mt: 1 }} variant='body2'>
              Hemos tenido problemas para validar tu transacción
            </Typography>
          </div>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            px: 3,
            py: 1.5,
          }}>
          <Button
            sx={{ mr: 2 }}
            variant='outlined'
            onClick={() => {
              onClose();
              navigate('/profilerisk');
            }}>
            Cancelar
          </Button>
          <ButtonXcalaBlue
            onClick={() => {
              onClose();
              navigate('/wallet');
            }}>
            ¡Reintentalo!
          </ButtonXcalaBlue>
        </Box>
      </Paper>
    </Container>
  );
};
export const ModalChooseTransfer = ({ onClose, fintocFailed }) => {
  const navigate = useNavigate();
  return (
    <Container maxWidth='sm'>
      <Paper elevation={12} sx={{ borderRadius: 4 }}>
        <Box
          sx={{
            display: 'flex',
            pb: 2,
            pt: 3,
            px: 3,
          }}>
          <Avatar
            sx={{
              backgroundColor: theme => alpha(theme.palette.success.main, 0.08),
              color: 'success.main',
              mr: 2,
            }}>
            <Warning fontSize='large' />
          </Avatar>

          <div>
            <Typography variant='h5'>¡Oh no! parece que algo salio mal</Typography>
            <Typography color='textSecondary' sx={{ mt: 1 }} variant='body2'>
              Hemos tenido problemas para completar tu transacción. Para seguir con la inversión,
              completa el próximo paso donde te explicaremos que hacer.
            </Typography>
          </div>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            px: 3,
            py: 1.5,
          }}>
          <Button
            sx={{ mr: 2 }}
            variant='outlined'
            onClick={async () => {
              onClose(true, fintocFailed);
              navigate('/profilerisk');
            }}>
            Cancelar
          </Button>
          <ButtonXcalaBlue
            onClick={async () => {
              onClose(false, fintocFailed);
            }}>
            ¡Continuar!
          </ButtonXcalaBlue>
        </Box>
      </Paper>
    </Container>
  );
};
export const InsufficientBalance = ({ onClose }) => {
  const navigate = useNavigate();
  return (
    <Container maxWidth='sm'>
      <Paper elevation={12} sx={{ borderRadius: 4 }}>
        <Box
          sx={{
            display: 'flex',
            pb: 2,
            pt: 3,
            px: 3,
          }}>
          <Avatar
            sx={{
              backgroundColor: theme => alpha(theme.palette.success.main, 0.08),
              color: 'success.main',
              mr: 2,
            }}>
            <Warning fontSize='large' />
          </Avatar>

          <div>
            <Typography variant='h5'>¡Oh no!</Typography>
            <Typography color='textSecondary' sx={{ mt: 1 }} variant='body2'>
              Parece que no dispones de saldo en tu caja
            </Typography>
          </div>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            px: 3,
            py: 1.5,
          }}>
          <ButtonXcalaBlue
            onClick={() => {
              onClose();
              navigate('/contact');
            }}>
            !Aceptar¡
          </ButtonXcalaBlue>
        </Box>
      </Paper>
    </Container>
  );
};
export const CompleteBankDetails = ({ onClose }) => {
  const navigate = useNavigate();
  return (
    <Container maxWidth='sm'>
      <Paper elevation={12} sx={{ borderRadius: 4 }}>
        <Box
          sx={{
            display: 'flex',
            pb: 2,
            pt: 3,
            px: 3,
          }}>
          <Avatar
            sx={{
              backgroundColor: theme => alpha(theme.palette.success.main, 0.08),
              color: 'success.main',
              mr: 2,
            }}>
            <Warning fontSize='large' />
          </Avatar>

          <div>
            <Typography variant='h5'>
              Necesitamos tus datos bancarios para completar el retiro. Por favor completalos.
            </Typography>
            <Typography color='textSecondary' sx={{ mt: 1 }} variant='body2'>
              Tu caja no dispone de saldo en este momento
            </Typography>
          </div>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            px: 3,
            py: 1.5,
          }}>
          <Button
            sx={{ mr: 2 }}
            variant='outlined'
            onClick={() => {
              onClose();
              navigate('/wallet');
            }}>
            Cancelar
          </Button>
          <ButtonXcalaBlue
            onClick={() => {
              onClose();
              navigate('/contact');
            }}>
            Completar mis datos
          </ButtonXcalaBlue>
        </Box>
      </Paper>
    </Container>
  );
};
// casos de exitos nuevos
export const WithdrawSuccess = ({ onClose }) => {
  const navigate = useNavigate();
  return (
    <Container maxWidth='sm'>
      <Paper elevation={12} sx={{ borderRadius: 4 }}>
        <Box
          sx={{
            display: 'flex',
            pb: 2,
            pt: 3,
            px: 3,
          }}>
          <Avatar
            sx={{
              backgroundColor: theme => alpha(theme.palette.success.main, 0.08),
              color: 'success.main',
              mr: 2,
            }}>
            <Check fontSize='large' />
          </Avatar>

          <div>
            <Typography variant='h5'>¡Solicitud Recibida!</Typography>
            <Typography color='textSecondary' sx={{ mt: 1 }} variant='body2'>
              Gestionaremos tu retiro y te avisaremos cuando vaya en camino a tu cuenta.
            </Typography>
          </div>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            px: 3,
            py: 1.5,
          }}>
          <ButtonXcalaBlue
            onClick={() => {
              onClose();
              navigate('/');
            }}>
            Aceptar
          </ButtonXcalaBlue>
        </Box>
      </Paper>
    </Container>
  );
};
export const SuccessfulRechargeAllYes = ({ onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || '/wallet';
  return (
    <Container maxWidth='sm'>
      <Paper elevation={12} sx={{ borderRadius: 4 }}>
        <Box
          sx={{
            display: 'flex',
            pb: 2,
            pt: 3,
            px: 3,
          }}>
          <Avatar
            sx={{
              backgroundColor: theme => alpha(theme.palette.success.main, 0.08),
              color: 'success.main',
              mr: 2,
            }}>
            <Check fontSize='large' />
          </Avatar>

          <div>
            <Typography variant='h5'>¡Gracias por operar con Xcala!</Typography>
            <Typography color='textSecondary' sx={{ mt: 1 }} variant='body2'>
              Puedes ver tu dinero reflejado en caja!
            </Typography>
          </div>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            px: 3,
            py: 1.5,
          }}>
          <ButtonXcalaBlue
            onClick={() => {
              onClose();
              navigate(-1);
            }}>
            Aceptar
          </ButtonXcalaBlue>
        </Box>
      </Paper>
    </Container>
  );
};
export const SuccessfulRecharge = ({ onClose }) => {
  const navigate = useNavigate();
  return (
    <Container maxWidth='sm'>
      <Paper elevation={12} sx={{ borderRadius: 4 }}>
        <Box
          sx={{
            display: 'flex',
            pb: 2,
            pt: 3,
            px: 3,
          }}>
          <Avatar
            sx={{
              backgroundColor: theme => alpha(theme.palette.success.main, 0.08),
              color: 'success.main',
              mr: 2,
            }}>
            <Check fontSize='large' />
          </Avatar>

          <div>
            <Typography variant='h5'>¡Recarga Exitosa!</Typography>
          </div>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            px: 3,
            py: 1.5,
          }}>
          <ButtonXcalaBlue
            onClick={() => {
              onClose();
              navigate('/contact');
            }}>
            Gracias
          </ButtonXcalaBlue>
        </Box>
      </Paper>
    </Container>
  );
};
export const SuccessfulInvestment = ({ onClose, fundName, amountInvestment }) => {
  const navigate = useNavigate();
  return (
    <>
      <StyledPaper>
        <WrapperBox>
          <GifContainer>
            <img src='/assets/images/sucess-gif.gif' alt='error' />
          </GifContainer>

          <TitleText gutterBottom>Inversión Exitosa</TitleText>
          <ProductName gutterBottom>{fundName}</ProductName>
          <LabelAmount gutterBottom>Monto de la inversión</LabelAmount>
          <AmountValue gutterBottom>{`$ ${amountInvestment}`}</AmountValue>
        </WrapperBox>

        <ButtonBox>
          <ButtonsPrimary
            name='Aceptar'
            onClick={() => {
              onClose();
              navigate('/myprofilerisk');
            }}
          />
        </ButtonBox>
      </StyledPaper>
    </>
  );
};
export const SuccessfulRechargeAllNo = ({ onClose }) => {
  return (
    <Container maxWidth='sm'>
      <Paper elevation={12} sx={{ borderRadius: 4 }}>
        <Box
          sx={{
            display: 'flex',
            pb: 2,
            pt: 3,
            px: 3,
          }}>
          <Avatar
            sx={{
              backgroundColor: theme => alpha(theme.palette.success.main, 0.08),
              color: 'success.main',
              mr: 2,
            }}>
            <Check fontSize='large' />
          </Avatar>

          <div>
            <Typography variant='h5'> ¡Gracias, por tu confianza,</Typography>
            <Typography color='textSecondary' sx={{ mt: 1 }} variant='body2'>
              verás tu dinero disponible en caja en un plazo no mayor a 24 horas!
            </Typography>
          </div>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            px: 3,
            py: 1.5,
          }}>
          <ButtonXcalaBlue
            onClick={() => {
              onClose();
            }}>
            ¡Aceptar!
          </ButtonXcalaBlue>
        </Box>
      </Paper>
    </Container>
  );
};
